export const environment = {
  apiUrl: 'https://utptechnology-backend.onrender.com/api/v1',
  firebaseConfig: {
    apiKey: "AIzaSyBkR4VfJnkle1Lovd1Sly2AkePKFHyq46k",
    authDomain: "utptechnology.firebaseapp.com",
    projectId: "utptechnology",
    storageBucket: "utptechnology.firebasestorage.app",
    messagingSenderId: "59762150451",
    appId: "1:59762150451:web:a1ed95461e323b42abe746"
  }
};

